// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-display {
  background-color: #f8f9fa;
  border-left: 4px solid #28a745;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
}

.question-text {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
  line-height: 1.5;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  border: 1px solid #f5c6cb;
}

.btn-humanize:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.text-area:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* File Upload Styles */
.file-upload-section {
  width: 100%;
}

.file-upload-area {
  margin-bottom: 1rem;
}

.file-input {
  display: none;
}

.file-upload-label {
  display: block;
  cursor: pointer;
  border: 2px dashed #28a745;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  background-color: #f8fffe;
  transition: all 0.3s ease;
}

.file-upload-label:hover {
  background-color: #f0fef0;
  border-color: #218838;
}

.file-upload-label:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #f5f5f5;
}

.file-upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.file-upload-icon {
  font-size: 2.5rem;
}

.file-upload-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
}

.file-upload-hint {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.uploaded-files-list {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
}

.uploaded-files-list h4 {
  margin: 0 0 0.75rem 0;
  font-size: 0.95rem;
  color: #212529;
}

.uploaded-files-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.uploaded-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #ffffff;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #e0e0e0;
}

.file-name {
  font-size: 0.9rem;
  color: #212529;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remove-file-btn {
  background-color: transparent;
  border: none;
  color: #dc3545;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: background-color 0.3s ease;
}

.remove-file-btn:hover:not(:disabled) {
  background-color: #ffe0e0;
}

.remove-file-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/QuestionBox.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".question-display {\n  background-color: #f8f9fa;\n  border-left: 4px solid #28a745;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 0.5rem;\n}\n\n.question-text {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #212529;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  border: 1px solid #f5c6cb;\n}\n\n.btn-humanize:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.text-area:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* File Upload Styles */\n.file-upload-section {\n  width: 100%;\n}\n\n.file-upload-area {\n  margin-bottom: 1rem;\n}\n\n.file-input {\n  display: none;\n}\n\n.file-upload-label {\n  display: block;\n  cursor: pointer;\n  border: 2px dashed #28a745;\n  border-radius: 0.5rem;\n  padding: 2rem;\n  text-align: center;\n  background-color: #f8fffe;\n  transition: all 0.3s ease;\n}\n\n.file-upload-label:hover {\n  background-color: #f0fef0;\n  border-color: #218838;\n}\n\n.file-upload-label:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n  background-color: #f5f5f5;\n}\n\n.file-upload-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.file-upload-icon {\n  font-size: 2.5rem;\n}\n\n.file-upload-text {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #212529;\n  margin: 0;\n}\n\n.file-upload-hint {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0;\n}\n\n.uploaded-files-list {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 0.5rem;\n}\n\n.uploaded-files-list h4 {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.95rem;\n  color: #212529;\n}\n\n.uploaded-files-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.uploaded-file-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background-color: #ffffff;\n  margin-bottom: 0.5rem;\n  border-radius: 0.5rem;\n  border: 1px solid #e0e0e0;\n}\n\n.file-name {\n  font-size: 0.9rem;\n  color: #212529;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.remove-file-btn {\n  background-color: transparent;\n  border: none;\n  color: #dc3545;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  transition: background-color 0.3s ease;\n}\n\n.remove-file-btn:hover:not(:disabled) {\n  background-color: #ffe0e0;\n}\n\n.remove-file-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
